export function validatePhoneNumber(phoneNumber: string) {
    var regex =
        /^(\+7|7|8)?[\s-]?\(?[489][0-9]{2}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{2}[\s-]?[0-9]{2}$/;

    if (regex.test(phoneNumber)) {
        return true;
    } else {
        return 'Номер телефона неверный';
    }
}

export function validateEmail(email: string) {
    var regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if (regex.test(email)) {
        return true;
    } else {
        return 'Email введен неверно';
    }
}
